var KeyboardKeyCodeEnum;
(function (KeyboardKeyCodeEnum) {
    KeyboardKeyCodeEnum["number0"] = "0";
    KeyboardKeyCodeEnum["number1"] = "1";
    KeyboardKeyCodeEnum["number2"] = "2";
    KeyboardKeyCodeEnum["number3"] = "3";
    KeyboardKeyCodeEnum["number4"] = "4";
    KeyboardKeyCodeEnum["number5"] = "5";
    KeyboardKeyCodeEnum["number6"] = "6";
    KeyboardKeyCodeEnum["number7"] = "7";
    KeyboardKeyCodeEnum["number8"] = "8";
    KeyboardKeyCodeEnum["number9"] = "9";
    KeyboardKeyCodeEnum["backspace"] = "backspace";
    KeyboardKeyCodeEnum["decimal"] = "decimal";
    KeyboardKeyCodeEnum["space"] = " ";
    KeyboardKeyCodeEnum["Q"] = "Q";
    KeyboardKeyCodeEnum["W"] = "W";
    KeyboardKeyCodeEnum["E"] = "E";
    KeyboardKeyCodeEnum["R"] = "R";
    KeyboardKeyCodeEnum["T"] = "T";
    KeyboardKeyCodeEnum["Y"] = "Y";
    KeyboardKeyCodeEnum["U"] = "U";
    KeyboardKeyCodeEnum["I"] = "I";
    KeyboardKeyCodeEnum["O"] = "O";
    KeyboardKeyCodeEnum["P"] = "P";
    KeyboardKeyCodeEnum["A"] = "A";
    KeyboardKeyCodeEnum["S"] = "S";
    KeyboardKeyCodeEnum["D"] = "D";
    KeyboardKeyCodeEnum["F"] = "F";
    KeyboardKeyCodeEnum["G"] = "G";
    KeyboardKeyCodeEnum["H"] = "H";
    KeyboardKeyCodeEnum["J"] = "J";
    KeyboardKeyCodeEnum["K"] = "K";
    KeyboardKeyCodeEnum["L"] = "L";
    KeyboardKeyCodeEnum["Z"] = "Z";
    KeyboardKeyCodeEnum["X"] = "X";
    KeyboardKeyCodeEnum["C"] = "C";
    KeyboardKeyCodeEnum["V"] = "V";
    KeyboardKeyCodeEnum["B"] = "B";
    KeyboardKeyCodeEnum["N"] = "N";
    KeyboardKeyCodeEnum["M"] = "M";
    KeyboardKeyCodeEnum["q"] = "q";
    KeyboardKeyCodeEnum["w"] = "w";
    KeyboardKeyCodeEnum["e"] = "e";
    KeyboardKeyCodeEnum["r"] = "r";
    KeyboardKeyCodeEnum["t"] = "t";
    KeyboardKeyCodeEnum["y"] = "y";
    KeyboardKeyCodeEnum["u"] = "u";
    KeyboardKeyCodeEnum["i"] = "i";
    KeyboardKeyCodeEnum["o"] = "o";
    KeyboardKeyCodeEnum["p"] = "p";
    KeyboardKeyCodeEnum["a"] = "a";
    KeyboardKeyCodeEnum["s"] = "s";
    KeyboardKeyCodeEnum["d"] = "d";
    KeyboardKeyCodeEnum["f"] = "f";
    KeyboardKeyCodeEnum["g"] = "g";
    KeyboardKeyCodeEnum["h"] = "h";
    KeyboardKeyCodeEnum["j"] = "j";
    KeyboardKeyCodeEnum["k"] = "k";
    KeyboardKeyCodeEnum["l"] = "l";
    KeyboardKeyCodeEnum["z"] = "z";
    KeyboardKeyCodeEnum["x"] = "x";
    KeyboardKeyCodeEnum["c"] = "c";
    KeyboardKeyCodeEnum["v"] = "v";
    KeyboardKeyCodeEnum["b"] = "b";
    KeyboardKeyCodeEnum["n"] = "n";
    KeyboardKeyCodeEnum["m"] = "m";
    KeyboardKeyCodeEnum["@"] = "@";
    KeyboardKeyCodeEnum["."] = ".";
    KeyboardKeyCodeEnum["_"] = "_";
    KeyboardKeyCodeEnum["-"] = "-";
    KeyboardKeyCodeEnum["plus"] = "+";
})(KeyboardKeyCodeEnum || (KeyboardKeyCodeEnum = {}));
export default KeyboardKeyCodeEnum;
//# sourceMappingURL=KeyboardKeyCodeEnum.js.map